import { Component } from '@angular/core';

@Component({
  selector: 'app-settings-maintenance-form',
  standalone: true,
  imports: [],
  templateUrl: './app-settings-maintenance-form.component.html',
  styleUrl: './app-settings-maintenance-form.component.css'
})
export class AppSettingsMaintenanceFormComponent {

}
